import axios, { AxiosError } from 'axios';

import { API_BASE_URL } from '@utils/constants/app-constants.ts';
import { ValidationError } from 'yup';
import { BaseError } from '@utils/types/shared/base.ts';

const Axios = axios.create({
  baseURL: API_BASE_URL,
  timeout: 300000,
  withCredentials: true
});

Axios.interceptors.response.use(
  r => r,
  (err: AxiosError<BaseError>) => {
    if (err.response?.status === 422 && err.response?.data?.error) {
      // ↪️ throw a friendly Error with .issues
      throw new ValidationError(err.response?.data?.error);
    }

    return Promise.reject(err);
  }
);

export { Axios };
